import { render, staticRenderFns } from "./PositionPicker.vue?vue&type=template&id=a3225a7c&"
import script from "./PositionPicker.vue?vue&type=script&lang=js&"
export * from "./PositionPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports